import api from '@pray/shared/utils/api';

export type ContentCategory = {
  id: string;
  name: string;
};

export async function getContentCategories({ artistId }: { artistId: string }) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/content-categories`;
  const response = await api.executeGetRequest(url);

  return (response.data as any).data;
}
